import React from 'react';

import type { ButtonProps } from '@sravni/react-design-system/dist/types/components/Button';

import type { IClientMicrocreditListItem } from '@src/@types/clienttypes';
import type { AffSub4 } from '@src/@types/microcredits';
import { AdvertisingButton } from '@src/components/AdvertisingButton';
import { AdvertisingLink } from '@src/components/AdvertisingLink/AdvertisingLink';
import { HAS_OFFER_SOURCE } from 'entities/Analytics';
import {
  fullDealCalculatorHasOffersData,
  TO_FULL_DEAL_BOTTOM_SHEET_BUTTON_DEFAULT_TEXT,
} from 'entities/FullDeal/config';
import { FULL_DEAL_WEB_TO_WEB_LINKS, FULL_DEAL_WEB_TO_WEB_SOURCE } from 'features/FullDeal/config';

import { buildHasOfferLinkForFullDeal } from '../../lib';

import styles from './FullDealCalculatorBottomSheetActions.module.scss';
import classNames from 'classnames';

interface Props {
  amount: number;
  term: number;
  hasOffer: boolean;
  toFullDealButtonText: string;

  offer: IClientMicrocreditListItem;
  position: number;
  color: ButtonProps['color'];
  className?: string;
}

export const FullDealCalculatorBottomSheetActions = ({
  amount,
  term,
  hasOffer: _hasOffer,
  toFullDealButtonText,
  color,
  offer,
  position,
  className,
}: Props) => {
  const { organization, name, _id } = offer;

  const affSub4ForMfoButton: AffSub4 = {
    organizationName: organization.name,
    productName: name,
    organizationId: organization._id,
    productId: _id,
  };

  const sourceAffC = `${HAS_OFFER_SOURCE}|position${position}`;
  const _toFullDealButtonText = toFullDealButtonText || TO_FULL_DEAL_BOTTOM_SHEET_BUTTON_DEFAULT_TEXT;

  return (
    <>
      <AdvertisingButton
        advSub={offer.advertising.advSub}
        analytics={offer}
        affSub4={fullDealCalculatorHasOffersData.affSub4}
        source={FULL_DEAL_WEB_TO_WEB_SOURCE.FROM_MODAL_OFFER}
        className={classNames(styles.advertisingButton, className)}
        block
        color={color}
        size={52}
        // @fix проверить параметр показа showAuth
        link={buildHasOfferLinkForFullDeal({
          link: FULL_DEAL_WEB_TO_WEB_LINKS.FROM_OFFER_MOBILE,
          offerId: offer.advertising.offerId,
          amount,
          term,
        })}
        visibleLabel={_toFullDealButtonText}
      />

      <AdvertisingLink
        advSub={offer.advertising.advSub}
        analytics={offer}
        affSub4={affSub4ForMfoButton}
        source={sourceAffC}
        block
        className={styles.advertisingButton}
        size={52}
        variant="secondary"
        visibleLabel={`Продолжить на сайте ${!offer?._features?.isSravniOffer ? offer.organization.name : ''}`}
      />
    </>
  );
};
